import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/home";
import VendorQuoteAssessment from "../pages/upcoming-negotiations/vendor-quote-assessment";
import VolumeAllocation from "../pages/upcoming-negotiations/volume-allocation";
import BusinessCostSetting from "../pages/business-cost/bc-setting";
import BusinessCostTrend from "../pages/business-cost/bc-trend";
import Navbar from "../components/navbar";
import VolumeCompliance from "../pages/compliance-monitoring/volume-compliance";
import OverallAllocationSummary from "../pages/upcoming-negotiations/volume-allocation/overall-summary";
import CostCompliance from "../pages/compliance-monitoring/cost-compliance";
import Reports from "../pages/reports/index";
import { PrimeReactProvider } from "primereact/api";
import NIAOpportunity from "../pages/nia-opportunity";
import Notifications from "../pages/notifications/Notifications";
import {
  ApplicationInsights,
  ITelemetryPlugin,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import UploadQuote from "../pages/upload-quote";
import ProtectedRoute from "../components/protected-route";
import { useAppSelector } from "../services/redux/hooks/hooks";
import Wirecontracts from "../pages/wire/wire-contracts";
import { Landing } from "../components/landing";
import { useEffect, useState } from "react";
import LviaTracking from "../pages/rebate-tracking/lvia-tracking";
import ServerError from "../pages/servererror";
import Settings from "../pages/settings";

const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
    disableFetchTracking: false,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin as unknown as ITelemetryPlugin],
    autoTrackPageVisitTime: true,
  },
});
appInsights.loadAppInsights();

const Router = () => {
  const [homeData, setHomeData] = useState(null);
  const disableScreens = useAppSelector((state) => {
    return state.disableScreens;
  });
  const volumeAllocationAccess = disableScreens?.volumeAllocation;
  const hasVolumeAllocationAccess =
    typeof volumeAllocationAccess === "boolean"
      ? volumeAllocationAccess
      : !!volumeAllocationAccess &&
        Object.values(volumeAllocationAccess).some(Boolean);
  const allocationSummaryAccess = disableScreens?.allocationSummary;
  const hasAllocationSummaryAccess =
    typeof allocationSummaryAccess === "boolean"
      ? allocationSummaryAccess
      : !!allocationSummaryAccess &&
        Object.values(allocationSummaryAccess).some(Boolean);
  const userData = useAppSelector((state) => {
    return state.user.userCommArray;
  });

  const userModuleData = useAppSelector((state) => state.user.userModuleArray);

  const isLead = useAppSelector((state) => {
    return state.user.role_name === "Lead";
  });

  return (
    <BrowserRouter>
      <div className="flex flex-nowrap w-full h-full">
        <div className="basis-[15%] grow-0 shrink-0">
          <Navbar homeData={homeData} ></Navbar>
        </div>
        <div className="basis-[85%] grow-0 shrink-0">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/home"
              element={
                <ProtectedRoute
                  screen="Home"
                  isDisabled={!userModuleData?.includes("HomePage")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <Home setHomeData={setHomeData} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute
                  screen="Notifications"
                  isDisabled={!userModuleData?.includes("Notifications")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <Notifications />
                </ProtectedRoute>
              }
            />

            <Route
              path="/quote-assessment"
              element={
                <ProtectedRoute
                  isDisabled={
                    // !disableScreens?.vendorQuoteAssesment ||
                    !userModuleData?.includes("Vendor Quote Assessment")
                  }
                  screen="vendor quote assesment"
                >
                  <VendorQuoteAssessment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/allocation"
              element={
                <ProtectedRoute
                  isDisabled={
                    !hasVolumeAllocationAccess ||
                    !userModuleData?.includes("Volumne Allocation")
                  }
                  screen="volume allocation"
                >
                  <VolumeAllocation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wirecontracts"
              element={
                <ProtectedRoute
                  screen="Home"
                  isDisabled={
                    !userModuleData?.includes("Wire Contract Tracking")
                  }
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <PrimeReactProvider>
                    <Wirecontracts />
                  </PrimeReactProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/allocation-summary"
              element={
                <ProtectedRoute
                  isDisabled={
                    !hasAllocationSummaryAccess ||
                    !userModuleData?.includes("Allocation Summary")
                  }
                  screen="allocation summary"
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <OverallAllocationSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cost-setting"
              element={
                <ProtectedRoute
                  isDisabled={
                    !disableScreens?.boardCost ||
                    !userModuleData?.includes("Board Cost Setting")
                  }
                  screen="board cost setting"
                >
                  <BusinessCostSetting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cost-trend"
              element={
                <ProtectedRoute
                  isDisabled={
                    !disableScreens?.boardCost ||
                    !userModuleData?.includes("Board Cost Trends")
                  }
                  screen="board cost trend"
                >
                  <BusinessCostTrend />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cost-metrics"
              element={
                <ProtectedRoute
                  screen="Cost Compliance"
                  isDisabled={!userModuleData?.includes("Cost Complaince")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <CostCompliance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nia-opportunity"
              element={
                <ProtectedRoute
                  screen="NIA Oppurtunity"
                  isDisabled={!userModuleData?.includes("NIA Opportunity")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <NIAOpportunity />
                </ProtectedRoute>
              }
            />
            <Route
              path="/volume-metrics"
              element={
                <ProtectedRoute
                  screen="Volume Compliance"
                  isDisabled={!userModuleData?.includes("Volume Complaince")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <PrimeReactProvider>
                    <VolumeCompliance />
                  </PrimeReactProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute
                  screen="Reports"
                  isDisabled={!userModuleData?.includes("Reports")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <PrimeReactProvider>
                    <Reports />
                  </PrimeReactProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload-quote"
              element={
                <ProtectedRoute
                  screen="Upload Quote"
                  isDisabled={!userModuleData?.includes("Quote Upload")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <UploadQuote />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lvia-tracking"
              element={
                <ProtectedRoute
                  screen="LVIA Rebate Tracking"
                  isDisabled={!userModuleData?.includes("Rebate Tracking")}
                  hasWire={userData?.includes("Copper Wire")}
                >
                  <LviaTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <Settings />
              }
            />
            <Route
              path="/server-error"
              element={
                <ServerError />
              }
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Router;
